import React from 'react';
import * as Imgs from 'assets/images';
import styled from 'styled-components';

export function Img({ src, alt, ...props }) {
  return <Image src={Imgs[src]} alt={Imgs[src]} {...props} />;
}

const Image = styled.img`
  ${({ onClick }) => onClick && `cursor:pointer`};
  width: 100%;
  height: 100%;
  object-fit: ${({ $objectFit }) => ($objectFit && $objectFit) || 'contain'};
`;
